import React from 'react';
import { getCrqList } from 'AppSrc/core/crq/crq-queries';
import { LoadingSpinner } from 'AppSrc/core/components/utility/loading-spinner';
import { Link } from 'react-router-dom';
import { RequestorRecentCrqTable } from './requestor-recent-crq-table';
import { CrqListErrorAlert } from '../crqs-screen/crq-list-error-alert';


class RequestorRecentCrqs extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      crqList: [],
      fetching: false,
      hasError: false,
    };
    this.clearError = this.clearError.bind(this);
  }

  componentDidMount() {
    this.setState({ fetching: true, hasError: false });
    // in this case we don't need to send any params
    // the API will send the requester ids for each network to TIL
    const params = {};
    getCrqList(params).then((data) => {
      // DISPATCH HERE FREYJA
      this.setState({
        fetching: false,
        crqList: data,
        hasError: false,
      });
    }).catch((error) => {
      console.error(error);
      this.setState({
        hasError: true,
        fetching: false,
      });
    });
  }

  clearError() {
    this.setState({ hasError: false });
  }

  render() {
    const { fetching, crqList, hasError } = this.state;
    if (fetching) {
      return (
        <div className="home-screen-loader">
          <LoadingSpinner />
        </div>
      );
    }
    const hasCrqs = crqList && crqList.length;
    return (
      <div className="page-content-inner requestor-recent-crqs">
        <h2>Recently Created CRQs</h2>
        <RequestorRecentCrqTable
          crqList={crqList}
        />
        {
          hasCrqs && (
            <div className="show-all-button">
              <Link to="/crqs">Show all</Link>
            </div>
          )
        }
        {
          hasError && (
            <CrqListErrorAlert
              clearError={this.clearError}
            />
          )
        }
      </div>
    );
  }

}


export { RequestorRecentCrqs };
